<template>
	<half-circle-spinner
		:animation-duration="1000"
		:size="40"
		color="#0e45ff"
	></half-circle-spinner>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
	components: {
		HalfCircleSpinner,
	},
}
</script>